module.exports = __webpack_public_path__ + "static/img/zlgj3dd.2e4b442.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/zlgj3dd.jpg
// module id = cvOn
// module chunks = 18